import { render, staticRenderFns } from "./-access-code.vue?vue&type=template&id=04a350db&scoped=true"
import script from "./-access-code.vue?vue&type=script&lang=js"
export * from "./-access-code.vue?vue&type=script&lang=js"
import style0 from "./-access-code.vue?vue&type=style&index=0&id=04a350db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a350db",
  null
  
)

export default component.exports